import React, { Component } from "react";
import PropTypes from "prop-types";
import { clone } from "../../../core/utils";
import { formatDate, formatStatus } from "../../../components/renderers";
import { create } from "../../../components/form/formgenerator";
//import {GridViewer} from '../../../components/grid';
import GridSwitch from "../../../components/grid/GridSwitch";
import { bizpost } from "../../../ajax";
import { extendedstyles } from "../../appstyles";
import { Box } from "@mui/material";

const s:any = {
  reqform: {
    //
  },
};

class ItemPanel extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props: any) {
    super(props);
    this.state = {
      // source: {},
      // preview: false,
      valid: true,
      // acl: 0,
      // count: 0,
      // loading: false,
      // data: [],
    };
  }

  componentDidMount() {
    this.props.setValid(this.state.valid);
  }

  //try and move this to ajax: async refresh(params,startfn,stopfn,errfn)
  // usage: await refresh(params,startfn.bind(this),stopfn.bind(this),errfn.bind(this))
  refresh = async (params: any) => {
    try {
      this.startLoading();
      const response = await bizpost(params);
      console.log("service response ", response);
      //TODO: build rows and add to state??
      this.setState({ data: response.sd, recordCount: +response.rc });
    } catch (err) {
      const error: any = err || {};
      // console.log(error);
      this.setState({ data: [], recordCount: 0 });
      //this.setState({recordCount:0});
      console.log("refresh error:", error);
      if (this.props.showNotification)
        this.props.showNotification(
          error.message || "request failed",
          error.type || "warn",
          error.title || "Loading Error"
        );
    } finally {
      if (this.state.loading) this.stopLoading();
    }
  };

  startLoading = () => {
    this.setState({ loading: true });
  };

  stopLoading = () => {
    this.setState({ loading: false });
  };
  /////////////////////////////////

  reload = (rec: any) => {
    if (!rec) return;
    if (!rec.rid) return;
    const params = { s: "service", a: "find", ati: rec.rid };
    this.refresh(params);
  };

  formconfig = () => {
    //combo.inputLabelProps => cilp
    //const cbip = {InputLabelProps:{ shrink:true,}};
    const config = {
      service:{
        name:'item',
        title:'Item',
        fields:['rid','nam','cti','ctn','ctc','iti','itn','itc','idn','mbn','eml','dsc','exi','sts','ast','stp'],
        grid: [['itc','Inspection'],['nam','Question'],['stc','State'],
             ['sts','Status'],['stp','Stamp']],
        menu: {mnu:[{t:'Customer',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
        eform:[
          // {id:'iti',label:'Inspection',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'inspection'}},
            //{id:'qni',label:'Question',type:'ms',req:1,ops:{t:'bcs',s:'itemquestion'},cp:{t:'bcs',s:'itemquestion'}},
            {id:'qni',label:'Question',type: 'ms', req: 1, ops:{params:{s:'itemquestion',a:'find'},conf:{keyField:'rid',accessField:'nam'}}},
            {id:'isi',label:'Item State',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'itemstate'}},
            // {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{}},
            
            //{id:'iei',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
          ],
      },
      create:true,
      actions: {add:'Add'},
      panels: {add:'simple'}
    };
    return config;
  };

  // setValid = (data: any) => {
  //   const valid = !!data.ati;
  //   //console.log('valid:',valid);
  //   this.props.setValid(valid);
  // };

  onChange = (name: any) => (value: any, m: any) => {
    console.log("form.onChange:", name, value, m, this.props.data);
    // var items:Array<any> = Array(value)
    // console.log("Create items array: ",[items]);
    const { data } = this.props;
    const newdata = { ...data.data, [name]: value }; //newval
    //this.setValid(newdata);
    this.props.setItem("data", "data", newdata);
    this.reload(m);
  };

  onSwitch = (recs: any) => {
    //onSwitch = (eform,data,mode) => {
    console.log("onSwitch.recs:", recs);
    const { data } = this.state;
    console.log("onSwitch.data:", data);
    //console.log('onSwitch.param3:',mode);
    //const ids = eform.reduce((acc,rec)=>( ( !!rec.req && (rec.off?!(rec.off.includes(mode)):true) )?[...acc,rec.id]:acc),[]);
    //console.log('ids = ',ids,', data = ',data);
    //const v = ids.reduce((acc,id)=>(acc&&(!!data[id]||data[id]===0)),true);
    //return v;
  };

  makeform = () => {
    const config = this.formconfig();

    const { record, extras, classes } = this.props;
    const sconfig = clone(config);
    const sdata = sconfig.service;
    const mode = "add";
    const formatters = { dob: formatDate };
    const onChange = this.onChange.bind(this);
    const form = create(
      mode,
      sdata,
      record,
      formatters,
      onChange,
      classes,
      extras
    );
    return form;
  };

  
  render() {
    const { classes } = this.props;
    const form = this.makeform();
    //const grid = this.makegrid();

    return (
      <Box sx={{...s.root}}>
        {form}
        {/* {grid} */}
      </Box>
    );
  }
}

ItemPanel.propTypes = {
  classes: PropTypes.object,
};

export default ItemPanel;
